import CircleCross from './CircleCross';

export default CircleCross;
